const FilterItemContainer = ({ children, ...props }) => {
  return children(props);
};

export default FilterItemContainer;
